import { useState, useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap'
import DataTable from 'react-data-table-component';
import { useSnackbar } from "notistack";
import { APIUrl } from '../../../Helper/APIUrl.js';
import { handleKeyPressString } from '../../../Helper/Helper.js';


function Title() {

    const Token = JSON.parse(localStorage.getItem('tcn'));
    const UserId = JSON.parse(localStorage.getItem('userid'));

    const { enqueueSnackbar } = useSnackbar();

    //Insert and Update UseStates
    const [HeroSectionId, setHeroSectionId] = useState("");
    const [Title, setTitle] = useState("");
    const [SubTitle, setSubTitle] = useState("");

    const [IsLive, setIsLive] = useState(true);
    const [IsActive, setisactive] = useState(true);
    const [CreatedBy, setCreatedBy] = useState(UserId);
    const [ModifiedBy, setModifiedBy] = useState(0);
    const [returnId, setreturnId] = useState(UserId);

    //Edit Populates States
    const [edit, setEdit] = useState(false);
    const [search, setsearch] = useState("");
    const [HeroSection, setAllHeroTitles] = useState([]);
    const [filterAUserProfile, setfilterAllHeroTitles] = useState([]);

    //Refs for input fields
    const TitleRef = useRef(null);
    const SubTitleRef = useRef(null);
    const NameRef = useRef(null);

    //API : Base Url + Controller Name
    const ConcateURL = APIUrl.HeroSection;


    // Safe JSON parse helper to avoid "Unexpected end of JSON input"
    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    function doEmptyStates() {

        setHeroSectionId("");
        setTitle("");
        setSubTitle("");
        setIsLive(true);
        setisactive(true);
        setEdit(false);
    }

    const getAllHeroSection = async () => {
        try {
            debugger;
            const response = await fetch(ConcateURL + 'GetAllHeroSection',
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify({})
                });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await parseJSON(response);
            if (result && result.data != null && result.Message == "Success") {
                setAllHeroTitles(result.data);
                console.log(result.data);
                setfilterAllHeroTitles(result.data);
            }
            else {
                setAllHeroTitles([]);
                setfilterAllHeroTitles([]);
            }
        }
        catch (error) {
            console.error("Error fetching Hero Section Data :", error);
            setAllHeroTitles([]);
            setfilterAllHeroTitles([]);
        }
    };


    useEffect(() => {
        if (!Token) {
            console.warn("No token found. Please login first.");
            // Redirect to login: window.location.href = '/login';
            enqueueSnackbar("Please login first", { variant: "warning" });
            return;
        }
        getAllHeroSection();
    }, []);



    const insertHeroSection = async () => {
        try {


            // Add JSON profile as string in "profileJson" field
            const HeroData = {
                Title, SubTitle, IsLive,
                IsActive, CreatedBy: UserId, ModifiedBy: UserId // Note: Match your model property name
            };


            const response = await fetch(ConcateURL + 'InsertHeroSection', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(HeroData)
            });

            const result = await response.json();

            if (result.isSuccess && result.Message === "Success") {
                getAllHeroSection();
                doEmptyStates();
                enqueueSnackbar("Successfully Added", { variant: "success" });
            } else {
                enqueueSnackbar(result.Message || "Failed to add user", { variant: "error" });
            }
        } catch (error) {
            console.error("Error:", error);
            enqueueSnackbar("Error adding Hero Section Data", { variant: "error" });
        }
    };


    const ValidateHeroSectionandSubmit = async () => {
        try {

            if (!Title || Title.length <= 3) {
                enqueueSnackbar("Title must be greater than 3 characters", { variant: "warning" });
                TitleRef.current.focus();
                return false;
            }
            if (!SubTitle || SubTitle.length <= 3) {
                enqueueSnackbar("Subtitle must be greater than 3 characters", { variant: "warning" });
                SubTitleRef.current.focus();
                return false;
            }

            insertHeroSection();
        }
        catch (error) {
            console.log(error);
        }
    };

    const coloumn = [
        {
            name: "SNo.",
            selector: (_, index) => index + 1
        },
        {
            name: "Title",
            selector: (row) => row.Title,
            sortable: true,
            reorder: true
        },
        {
            name: "SubTitle",
            selector: (row) => row.SubTitle,
        },
        // {
        //     name: <strong>Title Status</strong>,
        //     selector: (row) => !row.IsLive ? <span className="inline-flex px-3 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Deactivate</span> : <span className="inline-flex px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</span>,
        // },
        // {
        //     name: <strong>Title Live</strong>,
        //     width: "200px",
        //     selector: (row) => !row.IsLive ? <Button onClick={() => ToggleLiveHeroSection(row.HeroSectionId, "activate")} title="Click to Activate Title" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2">Click to Activate</Button> : <Button onClick={() => ToggleLiveHeroSection(row.HeroSectionId, "deactivate")} title="Click to Deactivate Title" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2">Click to Deactivate</Button>,
        // },

        {
            name: <strong>Activated/Deactivated</strong>,
            selector: (row) => row.IsActive ? <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label> : <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-yellow-800">Deactivated</label>,
        },
        {
            name: "Action",
            cell: row =>
                <div>
                    {
                        <>

                            {
                                !row.IsActive
                                    ?
                                    <Button onClick={() => activateDeactiveAUserProfile(row.HeroSectionId, "activate")} data-tip="Click to Activate User" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i className="fa fa-toggle-off" aria-hidden="true"></i></Button>
                                    :
                                    <Button onClick={() => activateDeactiveAUserProfile(row.HeroSectionId, "deactivate")} data-tip="Click to Deactivate User" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-toggle-on" aria-hidden="true"></i></Button>
                            }
                        </>
                    }&nbsp;&nbsp;
                    <Button onClick={() => editAUserProfiles(row.HeroSectionId)} data-tip="Click to Edit Details" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-pencil" aria-hidden="true"></i></Button>

                    {/* <Button onClick={() => DeleteAUserProfiles(row.ProfileId)} data-tip="Click to Delete" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"><i className="fa fa-trash" aria-hidden="true"></i></Button> */}
                </div>
        }
    ];

    const editAUserProfiles = async (Id) => {
        try {
            let items = HeroSection.filter(x => {
                return x.HeroSectionId === Id;
            });

            items.map(item => {
                setHeroSectionId(item.HeroSectionId)
                setTitle(item.Title)
                setSubTitle(item.SubTitle)
                setreturnId(item.HeroSectionId);

            })
            setEdit(true)
            NameRef.current.focus();
        }
        catch (error) {
            console.log(error);
        }
    };

    const UpdateHeroSection = async (Id) => {
        try {
            // Validation
            if (Title.length <= 3 || SubTitle.length <= 3) {
                enqueueSnackbar("Fill all required details to update", { variant: "error" });
                return;
            }

            // Add JSON profile as string in "profileJson" field (include ID)
            const HeroData = {
                HeroSectionId: Id,
                Title,
                SubTitle,
                ModifyBy: UserId
            };


            const response = await fetch(ConcateURL + 'UpdateHeroSection/' + Id, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(HeroData)
            });

            const result = await response.json();

            if (result.isSuccess && result.Message === "Success") {
                getAllHeroSection();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" });
            } else {
                enqueueSnackbar(result.Message || "Failed to update user", { variant: "error" });
            }
        } catch (error) {
            console.error("Error:", error);
            enqueueSnackbar("Error updating user profile", { variant: "error" });
        }
    };


    const activateDeactiveAUserProfile = async (Id, Value) => {
        try {
            let data = { HeroSectionId: Id, Value }
            const response = await fetch(ConcateURL + 'ActivateDeactivateHeroSection/' + Id,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify(data)
                });

            const result = await parseJSON(response);
            if (result) {
                getAllHeroSection();
                doEmptyStates();

                Value === "activate" ?
                    enqueueSnackbar("Successfully Activated", { variant: "success" })
                    :
                    enqueueSnackbar("Successfully Deactivated", { variant: "warning" });
            }
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar("Error updating status", { variant: "error" });
        }
    };

    const ToggleLiveHeroSection = async (Id, Value) => {
        try {
            debugger;
            let data = { HeroSectionId: Id, Value }
            const response = await fetch(ConcateURL + 'ToggleLiveHeroSection/' + Id,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify(data)
                });

            const result = await parseJSON(response);
            if (result) {
                getAllHeroSection();
                doEmptyStates();

                Value === "activate" ?
                    enqueueSnackbar("Successfully Activated", { variant: "success" })
                    :
                    enqueueSnackbar("Successfully Deactivated", { variant: "warning" });
            }
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar("Error updating live status", { variant: "error" });
        }
    };
    useEffect(() => {
        const result = HeroSection.filter(x => {
            return x.Title && x.Title.toLowerCase().match(search.toLowerCase());
        })

        setfilterAllHeroTitles(result);
    }, [search, HeroSection]);

    return (
        <div>


            <div className="space-y-6">
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-6">
                        Hero Title & Subtitle
                    </h2>
                    <div className='mb-4'>
                        <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2">
                            Add Title
                        </label>
                        <input
                            type="text"
                            ref={TitleRef}
                            value={Title}
                            onChange={(e) => { setTitle(e.target.value) }}
                            placeholder="Enter Title"
                            onKeyDown={handleKeyPressString}
                            maxLength={45}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                        />
                    </div>
                    <div>
                        <label htmlFor="subtitle" className="block text-sm font-medium text-gray-700 mb-2">
                            SubTitle
                        </label>
                        <input
                            type="text"
                            ref={SubTitleRef}
                            value={SubTitle}
                            onChange={(e) => { setSubTitle(e.target.value) }}
                            placeholder="Enter SubTitle"
                            onKeyDown={handleKeyPressString}
                            maxLength={90}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-4 mt-3">
                        {
                            edit ? <Button
                                className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                onClick={() => UpdateHeroSection(HeroSectionId)}
                            >
                                <span>Update</span>
                            </Button> :
                                <Button
                                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                    onClick={() => ValidateHeroSectionandSubmit()}
                                >
                                    <span>Submit</span>
                                </Button>
                        }


                        <button
                            type="button"
                            onClick={() => doEmptyStates()}
                            className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                        >
                            Reset
                        </button>

                    </div>



                </div>


            </div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                    <DataTable
                        title="Manage Title and Subtitle Data"
                        columns={coloumn}
                        data={filterAUserProfile}
                        pagination
                        fixedHeader
                        fixedHeaderScrollHeight="550px"
                        selectableRows
                        selectableRowsHighlight
                        highlightOnHover  // actions={<button className="btn btn-sm btn-info">Export</button>}                                                
                        subHeader
                        subHeaderAlign="right"
                        subHeaderComponent={
                            <input type="text"
                                placeholder="search username"
                                className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                value={search}
                                onChange={(e) => setsearch(e.target.value)}
                            />
                        }
                    />
                </div>
            </div>
        </div>




    )
}

export default Title